import { Injectable } from '@angular/core';

import { ComparisonOperator } from '@blaze-shared/api-contracts-domain';

import { IntelliConfig } from '../../core/models/intellisense';

@Injectable({
  providedIn: 'root',
})
export class FormulaEditorVisibilityService {
  shouldShowFormulaEditor(config: IntelliConfig | null | undefined): boolean {
    if (!config) {
      return false;
    }
    const operator = config?.operator;
    if (!operator) {
      return true;
    }
    return !this.isUnaryOperator(operator);
  }

  private isUnaryOperator(operator: ComparisonOperator | undefined): boolean {
    if (!operator) {
      return false;
    }
    const unaryOperators = [
      ComparisonOperator.IsTrue,
      ComparisonOperator.IsFalse,
      ComparisonOperator.IsNull,
      ComparisonOperator.IsNotNull,
    ];
    return unaryOperators.includes(operator);
  }
}
